<script>
   import { onMount } from "svelte";
    import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
    import backend from "../../../../../server";
 
    export let isshowDetail = false;
    export let bonusSelect;
    let isLoading = false; // Declaramos isLoading
    let bonuses = {};
    onMount(async () => {
    await getPlayesByCampaing();
  });

  const getPlayesByCampaing = async () => {
    try {
      console.log("Haciendo solicitud a la API...");
      isLoading = true;
      let response = await backend.freespin.getBonusById({ id: bonusSelect });
      bonuses = response.data.result.bonus; 
      console.log(response.data);
      console.log(bonuses);

      
    } catch (error) {
      console.error("Error al obtener los bonos:", error.message);
    }
    isLoading = false;
  };

  
  let statusMap = {
    10: { label: "PENDIENTE", class: "bg-warning" },
    20: { label: "RECLAMADO", class: "bg-info" }, 
    30: { label: "LISTO", class: "bg-success-light" },
    40: { label: "EN_JUEGO", class: "bg-primary" },
    90: { label: "CANCELADO", class: "bg-danger" },
    95: { label: "EXPIRADO", class: "bg-secondary" },
    100: { label: "COMPLETADO", class: "bg-success" }
};

    // Función para cerrar el modal
    const closeModal = () => {
      isshowDetail = false;
    };
 </script>
 
 <Modal isOpen={isshowDetail} size="xl">
    <ModalHeader>
      DETALLES DE LA RONDAS GRATIS : {bonusSelect}
    </ModalHeader>
    <ModalBody>
      <div class="freeSpin-modal">
        <section>
          <h5>Detalles del Bono</h5>
          {#if isLoading}
            <p>Cargando...</p>
          {:else}
            <!-- Mostrar detalles del bono -->
            <div class="bonus-details">
              <div class="row">
                <!-- Información del bono (col-4 para tres columnas) -->
                <div class="col-4">
                  <p><strong>Identificador del Bono:</strong> {bonuses.bonusId}</p>
                  <p><strong>Identificador de la Campaña:</strong> {bonuses.campaignId}</p>
                  <p><strong>Referencia de la Campaña:</strong> {bonuses.campaignRef}</p>
                </div>
                <div class="col-4">
                  <p><strong>ID del Jugador:</strong> {bonuses.playerId}</p>
                  <p><strong>Código del Operador:</strong> {bonuses.operatorCode}</p>
                  <p><strong>Código del Sitio:</strong> {bonuses.siteCode}</p>
                </div>
                <div class="col-4">
                  <p><strong>Moneda:</strong> {bonuses.currency}</p>
                  <p><strong>Tipo de Bono:</strong> {bonuses.type}</p>
                </div>
              </div>
              
              <!-- Razón de cancelación, URL de términos y estado (col-4 para tres columnas) -->
              <div class="row">
                <div class="col-4">
                  <p><strong>Razón de Cancelación:</strong> {bonuses.cancelReason || 'N/A'}</p>
                </div>
                <div class="col-4">
                  <p><strong>URL de Términos:</strong> {bonuses.termsUrl || 'N/A'}</p>
                </div>
                <div class="col-4">
                  <p> <span class={`badge ${statusMap[bonuses.status]?.class || 'bg-dark'}`}>
                    {statusMap[bonuses.status]?.label || 'Desconocido'}
                  </span></p>
                </div>
              </div>
              <!-- Línea de separación entre los requerimientos y la configuración -->
              
              <!-- Fechas (col-4 para tres columnas) -->
              <div class="row">
                <div class="col-4">
                  <p><strong>Fecha de Creación:</strong> {bonuses.timeCreated}</p>
                </div>
                <div class="col-4">
                  <p><strong>Fecha de Expiración:</strong> {bonuses.timeExpires}</p>
                </div>
                <div class="col-4">
                  <p><strong>Fecha de Reclamación:</strong> {bonuses.timeClaimed}</p>
                </div>
              </div>
              <!-- Línea de separación entre las fechas y los requerimientos del bono -->
              <hr class="separator" />
  
              <!-- Requerimientos del bono -->
              {#if bonuses.requirement}
                <h6>Requerimientos</h6>
                <div class="row">
                  <div class="col-4">
                    <p><strong>TTL:</strong> {bonuses.requirement.ttl}</p>
                    <p><strong>Minimo de Apuesta:</strong> {bonuses.requirement.minStake}</p>
                  </div>
                  <div class="col-4">
                    <p><strong>Minimo Total de Apuestas:</strong> {bonuses.requirement.minTotalBets}</p>
                  </div>
                  <div class="col-4">
                    <p><strong>Minimo Total de Apuesta:</strong> {bonuses.requirement.minTotalStake}</p>
                  </div>
                </div>
                <!-- Iterar sobre los juegos -->
                <div>
                  <strong>Juegos:</strong>
                  <div class="games">
                    {#each bonuses.requirement.games as game}
                      <span class="badge bg-secondary">{game}</span>
                    {/each}
                  </div>
                </div>
              {/if}
              
              <!-- Línea de separación entre los requerimientos y la configuración -->
              <hr class="separator" />
  
              <!-- Configuración del bono -->
              {#if bonuses.config}
                <h6>Configuración del Bono</h6>
                <div class="row">
                  <div class="col-4">
                    <p><strong>TTL:</strong> {bonuses.config.ttl}</p>
                  </div>
                  <div class="col-4">
                    <p><strong>Apuesta:</strong> {bonuses.config.stake}</p>
                  </div>
                  <div class="col-4">
                    <p><strong>Apuestas:</strong> {bonuses.config.bets}</p>
                  </div>
                </div>
                <!-- Iterar sobre los juegos -->
                <div>
                  <strong>Juegos:</strong>
                  <div class="games">
                    {#each bonuses.config.games as game}
                      <span class="badge bg-secondary">{game}</span>
                    {/each}
                  </div>
                </div>
              {/if}
  
              <!-- Línea de separación entre la configuración y los totales -->
              <hr class="separator" />
  
              <!-- Totales y demás detalles -->
              <div class="row">
                <div class="col-4">
                  <p><strong>Total de Apuestas:</strong> {bonuses.totalBets}</p>
                </div>
                <div class="col-4">
                  <p><strong>Total de Apuesta:</strong> {bonuses.totalStake}</p>
                </div>
                <div class="col-4">
                  <p><strong>Total de Pago:</strong> {bonuses.totalPayout}</p>
                </div>
              </div>
            </div>
          {/if}
        </section>
      </div>
    </ModalBody>
    <ModalFooter>
      <button class="btn btn-secondary" on:click={closeModal}>
        Cerrar
      </button>
    </ModalFooter>
  </Modal>
  
  
  
 
 <style>
  .bonus-details p {
  font-size: 14px;
  margin-bottom: 8px;
  }
  .separator {
  border: 1px solid #ccc; /* Color gris para la línea */
  margin: 20px 0; /* Espaciado superior e inferior */
  }


  .games {
  margin-top: 10px;
  }

  .badge {
  margin-right: 5px;
  margin-bottom: 5px;
  }
 </style>